module.exports = __webpack_public_path__ + "static/media/win.1cd33028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/types/win.jpg
// module id = 77
// module chunks = 0